import data from "@/config/template/Form/data.json"
import { CurrentAppResp } from "@/page/App/resp/currentAppResp"

export const FORM_DATA = data as unknown as CurrentAppResp
